export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9201.460a537a.jpg";